//
// LoadingWorkspace
//
// Show this when we're loading the application from the server

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { HView, Spacer, VView } from '../appview'
import { AboutPanel } from '../panels'

export const LoadingWorkspace = observer(function LoadingWorkspace(props) {
    const store = useStore()
    const app = store.app

    return (
        <VView grow>
            <VView className="worksheet">
                <HView>
                    <Spacer />
                    <VView className="form">
                        <Spacer size={20} />
                        <AboutPanel
                            version={store.version}
                            message={app.text('Loading...')}
                        />
                    </VView>
                    <Spacer />
                </HView>
            </VView>
        </VView>
    )
})
